"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_1 = require("../date");
var text_1 = require("../text");
var cleanJuridictionRoom_1 = __importDefault(require("./cleanJuridictionRoom"));
var filterFullText_1 = __importDefault(require("./filterFullText"));
var cleanDecisionData = function (decisionData) {
    var _a = decisionData.fullText, fullText = _a === void 0 ? '' : _a, data = __rest(decisionData, ["fullText"]);
    var dataWithoutBlankSpaces = (0, text_1.removeBlankSpaces)(data);
    var analysisInDecisionUpdatedAt = dataWithoutBlankSpaces.analysisInDecisionUpdatedAt, biblio = dataWithoutBlankSpaces.biblio, city = dataWithoutBlankSpaces.city, createdAt = dataWithoutBlankSpaces.createdAt, decisionStatus = dataWithoutBlankSpaces.decisionStatus, decisionType = dataWithoutBlankSpaces.decisionType, defendant = dataWithoutBlankSpaces.defendant, isFormatVerified = dataWithoutBlankSpaces.isFormatVerified, juridictionName = dataWithoutBlankSpaces.juridictionName, juridictionRoom = dataWithoutBlankSpaces.juridictionRoom, juridictionType = dataWithoutBlankSpaces.juridictionType, jury = dataWithoutBlankSpaces.jury, language = dataWithoutBlankSpaces.language, lawScopes = dataWithoutBlankSpaces.lawScopes, legislation = dataWithoutBlankSpaces.legislation, note = dataWithoutBlankSpaces.note, number = dataWithoutBlankSpaces.number, performedAt = dataWithoutBlankSpaces.performedAt, plaintiff = dataWithoutBlankSpaces.plaintiff, publicationStatus = dataWithoutBlankSpaces.publicationStatus, result = dataWithoutBlankSpaces.result, sameCase = dataWithoutBlankSpaces.sameCase, summary = dataWithoutBlankSpaces.summary, title = dataWithoutBlankSpaces.title, uniqueIds = dataWithoutBlankSpaces.uniqueIds;
    var cleanData = {
        analysisInDecisionUpdatedAt: analysisInDecisionUpdatedAt,
        biblio: biblio.map(function (_a) {
            var text = _a.text, url = _a.url;
            return (url ? { text: text, url: url } : { text: text });
        }),
        city: city,
        createdAt: createdAt,
        decisionStatus: decisionStatus,
        decisionType: decisionType,
        defendant: defendant,
        isFormatVerified: isFormatVerified,
        juridictionName: juridictionName,
        uniqueIds: uniqueIds,
        juridictionRoom: (0, cleanJuridictionRoom_1.default)(juridictionRoom),
        juridictionType: juridictionType,
        jury: jury.map(function (_a) {
            var names = _a.names, position = _a.position;
            return ({ names: names, position: position });
        }),
        language: language,
        lawScopes: lawScopes,
        legislation: legislation,
        note: note,
        number: number,
        performedAt: (0, date_1.getUTCDate)(performedAt),
        plaintiff: plaintiff,
        publicationStatus: publicationStatus,
        sameCase: sameCase,
        summary: summary,
        title: title,
        updatedAt: new Date(),
    };
    if (result) {
        cleanData.result = result;
    }
    return __assign({ fullText: (0, filterFullText_1.default)(fullText) }, cleanData);
};
exports.default = cleanDecisionData;
//# sourceMappingURL=cleanDecisionData.js.map